import { CSS } from '@grupoboticario/flora-react'

export const shippingGridCss: CSS = {
  gridTemplateColumns: 'repeat(1, 1fr)',
  '@desktop': {
    gridTemplateColumns: 'repeat(4, 1fr)'
  }
}
